export default __webpack_public_path__ + "static/60-sets-banner-mobile-448117b9262bea88f99e7d6536cca971.webp";